import type { JSX } from "react";
interface ConditionalRenderProps {
    rendered: boolean;
    children: JSX.Element;
}
// If you're not doing something like nesting ternaries, you probably don't need it
export const ConditionalRender = ({
    children,
    rendered,
}: ConditionalRenderProps): JSX.Element | null => {
    if (!rendered) {
        return null;
    }
    return children;
};
